// t() outside React (flow definitions: step names, titles, button labels).
// Uses the localization table already loaded by useT for the current language.
import { getValue } from "aldoo-ra/Value"
import { getTable, makeT } from "../hooks/useT"

export const flowT = (text, ...args) => {
  const lang = getValue("current-site-language", "current-site-language") || "en"
  return makeT(getTable(lang))(text, ...args)
}
